import { Component, EventEmitter, Input, OnInit, Output, signal } from '@angular/core';
import { ResidenceSearchResponse } from 'src/app/interfaces/api';
import { ResidenceService } from 'src/app/services/residence.service';
import { NgIf, NgFor } from '@angular/common';
import { Residence } from '../../models/residence.model';

@Component({
    selector: 'app-residence-list',
    templateUrl: './residence-list.component.html',
    styleUrls: ['./residence-list.component.scss'],
    imports: [NgIf, NgFor],
})
export class ResidenceListComponent implements OnInit {
  @Input() public noResidencesFoundForLetterMessage: string | null = '';

  @Output() private readonly showChange = new EventEmitter<boolean>();

  @Output() private readonly residenceSelected = new EventEmitter<Residence>();

  @Output() private readonly alternateResidence = new EventEmitter<string>();

  public readonly letterGroups = [
    'A - C',
    'D - F',
    'G - I',
    'J - L',
    'M - O',
    'P - R',
    'S - U',
    'V - Z',
  ];

  public readonly residences = signal<Residence[]>([]);

  public readonly currentList = signal<Residence[] | null>(null);

  public readonly currentGroup = signal('A - C');

  public readonly residencesLoaded = signal(false);

  constructor(private readonly residenceService: ResidenceService) {}

  ngOnInit(): void {
    this.residenceService.getResidencesGroupedByLetter('A', 'Z').subscribe({
      next: (res) => {
        const results = <ResidenceSearchResponse>res;
        this.residences.set(results.data.data);
      },
      error: () => {},
      complete: () => {
        this.residencesLoaded.set(true);
        this.selectList(this.currentGroup());
      },
    });
  }

  public selectResidence(residence: Residence): void {
    this.residenceSelected.emit(residence);
  }

  public doLivingAtHome(): void {
    this.alternateResidence.emit('im-living-at-home');
  }

  public doPrivateLet(): void {
    this.alternateResidence.emit('i-have-a-private-let-or-rental');
  }

  public isSelectable(group: string): boolean {
    return this.getList(group).length > 0;
  }

  private getList(group: string): Residence[] {
    const [start, end] = group.split(' - ');
    return this.residences()
      .filter((acc) => {
        const a = acc.name.toUpperCase().charAt(0);
        return a >= start && a <= end && acc.isSearchable;
      })
      .sort((a, b) => {
        if (a.name.toUpperCase() > b.name.toUpperCase()) return 1;
        if (a.name.toUpperCase() < b.name.toUpperCase()) return -1;
        return 0;
      });
  }

  public selectList(group: string): void {
    this.currentList.set(this.getList(group));
    this.currentGroup.set(group);
  }

  public isSelected(g: string): boolean {
    return g === this.currentGroup();
  }
}
